import { DataTestId } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { lt } from '@mews/framework';
import { Button, Stack } from '@optimus-web/core';
import { useRefundPaymentDialog } from '../../../tables/Payments/hooks';

interface PaymentDetailsRefundActionButtonProps extends WithAccountId {
    paymentId: string;
    closeDialog: () => void;
}

export const PaymentDetailsRefundActionButton = ({
    accountId,
    paymentId,
    closeDialog,
}: PaymentDetailsRefundActionButtonProps) => {
    const [renderCreateRefundPaymentDialog, toggleCreateRefundPaymentDialog] = useRefundPaymentDialog({
        paymentId,
        accountId,
        onSuccess: closeDialog,
    });

    return (
        <Stack alignment="end">
            <Button
                onClick={toggleCreateRefundPaymentDialog}
                type="button"
                data-test-id={DataTestId.RefundPaymentActionButton}
            >
                {lt('Refund')}
            </Button>
            {renderCreateRefundPaymentDialog()}
        </Stack>
    );
};
